import React, { useState } from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import { EditableList } from "../../EditableList";
import FileUpload from "../../FileUpload/FileUpload";

function AgreementUpload({
  agreementData,
  setAgreementData,
  handleSave,
  showPreview,
  setShowTable,
  getAgreementData,
  getSampleAgreementFile,
  isReadOnly,
}) {
  const [doc, setDoc] = useState({
    hospitalDoc: [],
    document: [],
    image: [],
    hospitalImage: [],
    documentIds: [],
  });

  return (
    <Grid
      container
      bgcolor={"white"}
      borderRadius={"5px"}
      mb={2}
      lg={12}
      sx={{ boxShadow: "rgba(149, 157, 165, 0.1) 0px 2px 14px;" }}>
      {!isReadOnly && (
        <Box height={156} padding={"18px 15px"}>
          <Typography
            sx={{
              fontWeight: "500",
              fontSize: "14px",
              color: "#2E2E2E",
            }}>
            Upload Documents
          </Typography>
          <Box
            padding={"10px 2px"}
            width={500}
            display={"flex"}
            justifyContent={"space-between"}>
            <Box width={"45%"}>
              <FileUpload
                id="hospital"
                doc={agreementData}
                setDoc={setAgreementData}
                type="hospitalDoc"
              />
              <EditableList
                onUploadClick={(val, index) => {
                  const updatedImages = [...agreementData.hospitalDoc];
                  updatedImages.splice(index, 1);
                  setAgreementData((s) => ({
                    ...s,
                    hospitalDoc: updatedImages,
                  }));
                }}
                onResponseClick={(val, index) => {
                  const updatedImages = [...agreementData.document];
                  updatedImages.splice(index, 1);
                  setAgreementData((s) => ({
                    ...s,
                    document: updatedImages,
                    documentIds: [...s.documentIds, val.documentId],
                  }));
                }}
                responseDoc={agreementData.document}
                uploadDoc={agreementData?.hospitalDoc}
              />
            </Box>
            {agreementData.hospitalDoc.length === 0 && (
              <>
                <Box
                  width={"165px"}
                  fontSize={"14px"}
                  border={"#414851"}
                  sx={{
                    textTransform: "capitalize",
                    border: "1px solid black",
                    color: "#414851",
                    fontWeight: 400,
                  }}
                  height={"36px"}
                  component={Button}
                  onClick={() => getSampleAgreementFile()}>
                  Download CSV
                </Box>
              </>
            )}
            {agreementData.hospitalDoc.length !== 0 && (
              <Box
                width={"65px"}
                fontSize={"14px"}
                border={"#414851"}
                sx={{
                  textTransform: "capitalize",
                  border: "1px solid black",
                  color: "#414851",
                  bgcolor: "#F2F9F6",
                  fontWeight: 400,
                }}
                height={"36px"}
                component={Button}
                onClick={() => {
                  handleSave();
                  // getAgreementData();
                }}>
                Save
              </Box>
            )}
            {/* {agreementData.hospitalDoc.length === 1 && (
            <>
              {" "}
              {showPreview && (
                <Box
                  width={"75px"}
                  fontSize={"14px"}
                  border={"#414851"}
                  sx={{
                    textTransform: "capitalize",
                    border: "1px solid black",
                    color: "#414851",
                    bgcolor: "#F2F9F6",
                    fontWeight: 500,
                  }}
                  height={"36px"}
                  component={Button}
                  onClick={() => setShowTable((c) => !c)}>
                  Preview
                </Box>
              )}
            </>
          )} */}
          </Box>
        </Box>
      )}
    </Grid>
  );
}

export default AgreementUpload;
